import {
    ENTITY_PART_TYPE_KNOWN,
    ENTITY_PART_TYPE_CUSTOM,
    ENTITY_PART_TYPE_SEPARATOR,
    ENTITY_PART_TYPE_PLACEHOLDER,
} from './common/EntityPart';

export const createKnownCargoPart = (cargo) => {
    return createPart(
        cargo.id,
        ENTITY_PART_TYPE_KNOWN,
        cargo.name,
        cargo.cleanDirty
    );
};

export const createCustomCargoPart = (cargo) => {
    return createPart(cargo.name, ENTITY_PART_TYPE_CUSTOM, null, null);
};

export const createSeparatorCargoPart = (character) => {
    return createPart(character, ENTITY_PART_TYPE_SEPARATOR, null, null);
};

export const createPlaceholderCargoPart = (character) => {
    return createPart(character, ENTITY_PART_TYPE_PLACEHOLDER, null, null);
};

const createPart = (value, partType, name, cleanDirty) => {
    return {
        value,
        partType,
        name,
        cleanDirty,
    };
};
